import moment from 'moment'

angular.module('surfsightApp.controllers').controller('mapMediaPlayersCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$mdMedia',
  'edgeFactoryV2',
  'edgeGroupFactory',
  'broadcastViewFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  '$translate',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $mdMedia,
    edgeFactoryV2,
    edgeGroupFactory,
    broadcastViewFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    $translate1
  ) {
    $scope.dashcamStreams = []
    const $translate = $filter('translate')
    $scope.currentState = $state.current.name
    $scope.userToken = $localStorage.userToken
    $scope.currentUserOrganizationId = $localStorage.currentUserOrganization.id
    const dashcamEvents = []
    const dashcamLiveVideos = []
    $scope.edge = {}
    $scope.dashcamEvents = dashcamEvents
    $scope.dashcamLiveVideos = dashcamLiveVideos
    $scope.$on('eventsVideoAddedEmit', function (e, data) {
      const event = data.event
      $scope.edge = data.edge
      const dashcamEventIndex = dashcamEvents.findIndex(
        de => de.id === event.id
      )
      if (dashcamEventIndex === -1) {
        dashcamEvents.push({
          ...event,
          AMPLITUDE_KEY,
          imei: data.edge.imei,
          dateString: moment(event.time).format('MMM ddd DD YYYY'),
          timeString: `${moment(event.time)
            .toDate()
            .toLocaleTimeString('en-US', {
              hour12: true,
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZoneName: 'short'
            })} (${new Date()
            .toLocaleTimeString('en-US', {
              timeZoneName: 'long',
              hour12: false
            })
            .slice(9)})`,
          addressString: `${event.lat},${event.lon}`,
          get translationsSrc () {
            return `./locale/lytx-event-media/${$translate1.use()}.json`
          }
        })
      }
      if (dashcamEvents.length > 1) {
        $timeout(() => {
          const element = document.getElementById(`map-media-event-${event.id}`)
          element &&
            element.scrollIntoView({
              behavior: 'smooth'
            })
        })
      }
    })
    $scope.$on('closeMapMediaPlayers', () => {
      $scope.closeMapMediaPlayersSidenav()
    })
    if (
      [
        'home.common.edge.options',
        'home.common.edge.options.streams',
        'home.common.edge.options.cameras',
        'home.common.edge.options.settings',
        'home.common.edge.options.settings',
        'home.common.edge.options.settings.Maintenance'
      ].indexOf($scope.currentState) > 0
    ) {
      $timeout(function () {
        // $scope.openSideNav('edge-list');
        if ($mdMedia('gt-sm')) {
          $mdSidenav('map-media-players').open()
        }
      })
    }
    $scope.componentErrorLytxEventMedia = e => {
      console.log(e)
    }

    $scope.closeEventVideo = id => {
      const index = $scope.multipleEventsVideos.findIndex(e => e.id === id)
      index > -1 && $scope.multipleEventsVideos.splice(index, 1)
      verifyAllPlayers()
    }
    $scope.closeMapBroadcastView = function () {
      $scope.broadcastViewId = 0
    }
    $scope.mdMedia = function (q) {
      return $mdMedia(q)
    }
    $scope.closeMapMediaPlayersSidenav = () => {
      clearEventMediaPlayers()
      $mdSidenav('map-media-players').close()
    }
    const clearEventMediaPlayers = () => {
      dashcamEvents.splice(0, dashcamEvents.length)
    }
    const clearLiveVideos = () => {
      dashcamLiveVideos.splice(0, dashcamLiveVideos.length)
    }
  }
])
